import { hasPermission } from './Permissions'

export const canCustomerServiceFollowUpCreate = () =>
    hasPermission('sia.manage.atencion-cliente.follow_up.create')

export const canCustomerServiceFollowUpView = () =>
    hasPermission('sia.manage.atencion-cliente.follow_up.view')

export const canCustomerServiceBitacoraView = () =>
    hasPermission('sia.manage.atencion-cliente.bitacora.view')

export const canCustomerServiceBitacoraExport = () =>
    hasPermission('sia.manage.atencion-cliente.bitacora.export')

export const canCustomerServiceViewAll = () =>
    hasPermission('sia.manage.atencion-cliente.view_all')
